exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n@media only screen and (max-width: 600px) {\n    .image-uploader-container {\n        display:flex;\n        align-items:baseline;\n    }\n}\n", ""]);

// exports
